var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.318,
    height: 13.036,
    viewBox: "22.605 157.039 19.318 13.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.774 158.192-8.934 11.593a.714.714 0 0 1-1.14.013l-8.91-11.561a.717.717 0 0 1 .531-1.198H41.21v.002a.713.713 0 0 1 .565 1.151Z",
    fill: "#ea5455",
    fillRule: "evenodd",
    "data-name": "triangle-top-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.07e04a29c63ee053c3d1a9341b2b7e44.svg";
export { ForwardRef as ReactComponent };